<template>
    <div class="user_core">
        <Header :title="title"></Header>
        <van-row class="info_body">
            <van-col span="24" class="info_s">
                <van-tabs @click="onClick">
                    <van-tab :title="$t('financial.tabtitle1')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                    <van-tab :title="$t('financial.tabtitle2')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                    <van-tab :title="$t('financial.tabtitle3')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                    <van-tab :title="$t('financial.tabtitle4')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                    <van-tab :title="$t('financial.tabtitle5')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                    <van-tab :title="$t('financial.tabtitle6')">
                        <Flist :tabindex="tabindex"></Flist>
                    </van-tab>
                </van-tabs>
            </van-col>
        </van-row>
        <Footer></Footer>
    </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import Flist from '@/components/user/Flist'
    export default {
        name: "Financial",
        data(){
            return{
                title:this.$t('financial.pagetitle'),
                active: 1,
                tabindex : 0
            }
        },
        components:{
            Header,
            Footer,
            Flist
        },

        methods: {
            onClick(name, title) {
                //this.$toast(title);
               this.tabindex = name;
            },

        },
    }
</script>

<style scoped lang="scss">
    .user_core{
        height: 650px;
        background: url("~@/assets/images/bg_header.png") no-repeat center 0%;
        background-size: 100% ;
        .info_body{
            width: 92%;
            height: 600px;
            margin: 15px 15px 30px 15px;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
            .info_s{
                margin: 20px auto;

                }
            }
    }
</style>
